import styled from 'styled-components';
import { HelpCircle } from '../Icons/Base';

export const HelpIcon = styled(HelpCircle)`
  margin-left: 2px;
`;
